import React from 'react';
import { Typography } from '../../../../../electrons';
import { ColorField } from '../../../../formFields';
import { QR_CODE_SETTINGS_DEFAULTS } from '../../../constants/QrCodeSettingsDefaults';
import { useColorService } from '../../../hooks/useColorService/useColorService';
import { ColorStyles } from './Color.styles';
const Color = (props) => {
    const { codeColor = QR_CODE_SETTINGS_DEFAULTS.code_color, backgroundColor = QR_CODE_SETTINGS_DEFAULTS.background_color, finderPatternColor = QR_CODE_SETTINGS_DEFAULTS.finder_pattern_color, onCodeColorChange, onBackgroundColorChange, onFinderPatternColorChange, } = props;
    const colorService = useColorService({
        onCodeColorChange,
        onBackgroundColorChange,
        onFinderPatternColorChange,
    });
    return (React.createElement("div", { className: ColorStyles.container },
        React.createElement("div", { className: ColorStyles.colorInputContainer },
            React.createElement(Typography, { variant: "subtitle1", className: ColorStyles.text }, "Code Color"),
            React.createElement(ColorField, { id: "code-color-palette", value: codeColor, onChange: colorService.handleColorChange })),
        React.createElement("div", { className: ColorStyles.colorInputContainer },
            React.createElement(Typography, { variant: "subtitle1", className: ColorStyles.text }, "Background Color"),
            React.createElement(ColorField, { id: "background-color-palette", value: backgroundColor, onChange: colorService.handleBackgroundColorChange })),
        React.createElement("div", { className: ColorStyles.colorInputContainer },
            React.createElement(Typography, { variant: "subtitle1", className: ColorStyles.text }, "Finder Color"),
            React.createElement(ColorField, { id: "finder-color-palette", value: finderPatternColor, onChange: colorService.handleFinderPatternColorChange }))));
};
export default Color;
//# sourceMappingURL=Color.js.map